export const accessControl: {
  [feature: string]: { [role in PracticeRole]: boolean };
} = {
  dashboard: {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'business-analytics': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  calendar: {
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'patient-charts': {
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'notes-and-forms': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  billing: {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'orchid-storage': {
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  settings: {
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  messaging: {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  invite: {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  policies: {
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'calendar-sync': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'client-chart-notes': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'client-chart-medication-history': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'client-chart-treatment-plans': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'client-chart-measurements': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'client-chart-attachments': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  "edit-scheduling": {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  //Hide these tabs for practice scheduler
  'profileTab': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'practiceSetting': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'directory': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'notificationsTab': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'integrationsTab': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'aiSettingsTab': {
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  'telehealthTab':{
    OWNER: true,
    PRACTICE_SCHEDULER: false,
  },
  //show these tabs
  'clientPortalTab':{
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'billingTab':{
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'patientAnalyticsTab':{
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  },
  'accountTab':{
    OWNER: true,
    PRACTICE_SCHEDULER: true,
  }
};
